/* eslint-disable @typescript-eslint/no-empty-function */
import { Box, DialogTitle, Drawer, Grid, IconButton, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import {
    HistoryDetailsDialogStore,
    LeadActivity,
    LeadScreenStore,
    LeadSingleActivityStore,
} from '../../../stores/LeadStore';
import CancelIcon from '@mui/icons-material/Cancel';
import Close from 'mdi-material-ui/Close';
import LeadDataFormater from './LeadDataFormater';
import Divider from '@mui/material/Divider';
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import QuestionAnswerTwoToneIcon from '@mui/icons-material/QuestionAnswerTwoTone';
import { formatDateLocal } from 'src/utils/date-utils';
import { client } from '../../../utils/axios-client';
import { leadEndpoints } from '../../../configs/endpoints';
import ReactAudioPlayer from 'react-audio-player';
import StandardSkeleton from '../../common/StandardSkeleton';
import DateTimeDisplayWithLabel from '../../common/DateTimeDisplayWithLabel';
import ContentEditor from '../../../v2/components/ContentEditor/ContentEditor';
import { TokenType } from '../../../v2/components/ContentEditor/types/content-editor-types';

const DoActivityDetails = () => {
    const activityId = HistoryDetailsDialogStore.useState((s) => s.activityId);
    const activity = LeadSingleActivityStore.useState((s) => s.record);
    const [hasLoaded, setHasLoaded] = useState(false);

    useEffect(() => {
        const fetchActivity = async () => {
            setHasLoaded(false);
            const response = await client.get(leadEndpoints.getsingleactivity.replace('{activityid}', '' + activityId));
            LeadSingleActivityStore.update((s) => {
                s.record = response.data;
            });
            setHasLoaded(true);
        };
        if (activityId != null && activityId != '') fetchActivity();
    }, []);

    const cadence = {
        name: activity.currentCadenceName + ' - Step: ' + activity.currentCadenceStep,
    };
    const nextCadence = {
        name: activity.nextCadenceName != '' ? activity.nextCadenceName + ' - Step: ' + activity.nextCadenceStep : '',
    };

    if (hasLoaded) {
        return (
            <PerfectScrollbar options={{ wheelPropagation: false }}>
                <Box sx={{ p: 5, height: 750, maxHeight: 750 }}>
                    {!activity.isAction && (
                        <Grid container spacing={2} justifyContent={'center'}>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Activity:"
                                    valueText={activity.currentActivityName}
                                    textColor=""
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <DateTimeDisplayWithLabel
                                    value={formatDateLocal(activity.currentActivityDate)}
                                    label="Date:"
                                    format="datetime"
                                    sx={{ mr: 2, fontWeight: 500, fontSize: '0.875rem' }}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Completed By:"
                                    valueText={activity.currentActivityOwnerName}
                                    textColor=""
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Sprint:"
                                    valueText={activity.sprintName}
                                    textColor=""
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={8}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Cadence:"
                                    valueText={cadence.name}
                                    textColor=""
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Initial Stage:"
                                    valueText={activity.currentStageName}
                                    textColor={activity.currentStageColor}
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={true}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                {activity.currentActivitySubOutcomeName == '' && (
                                    <LeadDataFormater
                                        labelText="Outcome:"
                                        valueText={activity.currentActivityOutcomeName}
                                        textColor={activity.currentActivityOutcomeButtonColor}
                                        errorText="-Unknown-"
                                        chipHeight={20}
                                        chipFontSize="0.75rem"
                                        chipfontWeight={500}
                                        isChip={true}
                                    />
                                )}
                                {activity.currentActivitySubOutcomeName != '' && (
                                    <Box>
                                        <LeadDataFormater
                                            labelText="Outcome:"
                                            valueText={activity.currentActivityOutcomeName}
                                            textColor={activity.currentActivityOutcomeButtonColor}
                                            errorText="-Unknown-"
                                            chipHeight={20}
                                            chipFontSize="0.75rem"
                                            chipfontWeight={500}
                                            isChip={true}
                                        />
                                        <LeadDataFormater
                                            labelText="-"
                                            valueText={activity.currentActivitySubOutcomeName}
                                            textColor={activity.currentActivitySubOutcomeColor}
                                            errorText="-Unknown-"
                                            chipHeight={20}
                                            chipFontSize="0.75rem"
                                            chipfontWeight={500}
                                            isChip={true}
                                        />
                                    </Box>
                                )}
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="New Stage:"
                                    valueText={activity.nextStageName}
                                    textColor={activity.nextStageColor}
                                    errorText="-Not Set-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={true}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Next Activity:"
                                    valueText={activity.nextActivityName}
                                    textColor=""
                                    errorText="-Not Set-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={8}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Next Activity Date:"
                                    valueText={
                                        activity.nextActivityDate != null
                                            ? formatDateLocal(activity.nextActivityDate)
                                            : ''
                                    }
                                    textColor=""
                                    errorText="-Not Set-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Next Cadence:"
                                    valueText={nextCadence.name}
                                    textColor=""
                                    errorText="-Not Set-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sx={{ pt: 1, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 1 }}
                            >
                                <Divider />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 1 }}
                            >
                                <Typography sx={{ mr: 2, fontWeight: 500, fontSize: '0.875rem' }}>
                                    Activity Notes:
                                </Typography>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sx={{ pt: 1, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <Typography variant="body2">{activity.notes}</Typography>
                            </Grid>
                        </Grid>
                    )}
                    {activity.discoveryCallAttendees.length > 0 && (
                        <Grid container spacing={2} justifyContent={'center'}>
                            <Grid
                                item
                                xs={12}
                                sx={{ pt: 1, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 1 }}
                            >
                                <Divider />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sx={{ pt: 1, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 1 }}
                            >
                                <Typography sx={{ mr: 2, fontWeight: 500, fontSize: '0.875rem' }}>Attendees</Typography>
                            </Grid>
                        </Grid>
                    )}
                    {activity.discoveryCallAttendees.map((record) => (
                        <Grid container spacing={2} justifyContent={'center'}>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Name:"
                                    valueText={record.fullName}
                                    textColor=""
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Email:"
                                    valueText={record.email}
                                    textColor=""
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Job title:"
                                    valueText={record.jobTitle}
                                    textColor=""
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                        </Grid>
                    ))}
                    {!activity.isAction &&
                        (activity.currentActivityName == 'Outbound Phone Call' ||
                            activity.currentActivityName == 'Inbound Phone Call') && (
                            <Grid container spacing={2} justifyContent={'center'}>
                                <Grid
                                    item
                                    xs={12}
                                    sx={{ pt: 1, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 1 }}
                                >
                                    <Divider />
                                </Grid>
                                <Grid
                                    item
                                    xs={4}
                                    sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                                >
                                    <LeadDataFormater
                                        labelText="Number Called:"
                                        valueText={activity.phoneTo}
                                        textColor=""
                                        errorText="-Not Set-"
                                        chipHeight={20}
                                        chipFontSize="0.75rem"
                                        chipfontWeight={500}
                                        isChip={false}
                                    />
                                </Grid>
                                <Grid
                                    item
                                    xs={4}
                                    sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                                >
                                    <LeadDataFormater
                                        labelText="Called From:"
                                        valueText={activity.phoneFrom}
                                        textColor=""
                                        errorText="-Not Set-"
                                        chipHeight={20}
                                        chipFontSize="0.75rem"
                                        chipfontWeight={500}
                                        isChip={false}
                                    />
                                </Grid>
                                <Grid
                                    item
                                    xs={4}
                                    sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                                >
                                    <LeadDataFormater
                                        labelText="Call Status:"
                                        valueText={activity.callStatus}
                                        textColor=""
                                        errorText="-Not Set-"
                                        chipHeight={20}
                                        chipFontSize="0.75rem"
                                        chipfontWeight={500}
                                        isChip={false}
                                    />
                                </Grid>
                                <Grid
                                    item
                                    xs={4}
                                    sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                                >
                                    <LeadDataFormater
                                        labelText="Call Start:"
                                        valueText={
                                            activity.callStartTime != null ? activity.callStartTime.toString() : ''
                                        }
                                        textColor=""
                                        errorText="-Not Set-"
                                        chipHeight={20}
                                        chipFontSize="0.75rem"
                                        chipfontWeight={500}
                                        isChip={false}
                                    />
                                </Grid>
                                <Grid
                                    item
                                    xs={4}
                                    sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                                >
                                    <LeadDataFormater
                                        labelText="Call Duration:"
                                        valueText={activity.durationSeconds}
                                        textColor=""
                                        errorText="-Not Set-"
                                        chipHeight={20}
                                        chipFontSize="0.75rem"
                                        chipfontWeight={500}
                                        isChip={false}
                                    />
                                </Grid>
                                <Grid
                                    item
                                    xs={4}
                                    sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                                >
                                    <LeadDataFormater
                                        labelText="Call Cost:"
                                        valueText={activity.callCost}
                                        textColor=""
                                        errorText="-Not Set-"
                                        chipHeight={20}
                                        chipFontSize="0.75rem"
                                        chipfontWeight={500}
                                        isChip={false}
                                    />
                                </Grid>
                                {activity.recording != '' && (
                                    <Grid
                                        item
                                        xs={12}
                                        sx={{
                                            pt: 1,
                                            display: 'flex',
                                            alignItems: 'left',
                                            flexDirection: 'column',
                                            mb: 1,
                                        }}
                                    >
                                        <Typography variant="body2">Call Recording: </Typography>
                                    </Grid>
                                )}
                                {activity.recording != '' && (
                                    <Grid
                                        item
                                        xs={12}
                                        sx={{
                                            pt: 1,
                                            display: 'flex',
                                            alignItems: 'left',
                                            flexDirection: 'column',
                                            mb: 1,
                                        }}
                                    >
                                        <ReactAudioPlayer src={activity.recording} controls={true} />
                                    </Grid>
                                )}
                            </Grid>
                        )}
                    {!activity.isAction &&
                        (activity.currentActivityName == 'Outbound SMS' ||
                            activity.currentActivityName == 'Inbound SMS') && (
                            <Grid container spacing={2} justifyContent={'center'}>
                                <Grid
                                    item
                                    xs={12}
                                    sx={{ pt: 1, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 1 }}
                                >
                                    <Divider />
                                </Grid>
                                <Grid
                                    item
                                    xs={4}
                                    sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                                >
                                    <LeadDataFormater
                                        labelText="Number Messaged:"
                                        valueText={activity.phoneTo}
                                        textColor=""
                                        errorText="-Not Set-"
                                        chipHeight={20}
                                        chipFontSize="0.75rem"
                                        chipfontWeight={500}
                                        isChip={false}
                                    />
                                </Grid>
                                <Grid
                                    item
                                    xs={4}
                                    sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                                >
                                    <LeadDataFormater
                                        labelText="Messaged From:"
                                        valueText={activity.phoneFrom}
                                        textColor=""
                                        errorText="-Not Set-"
                                        chipHeight={20}
                                        chipFontSize="0.75rem"
                                        chipfontWeight={500}
                                        isChip={false}
                                    />
                                </Grid>
                                <Grid
                                    item
                                    xs={4}
                                    sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                                >
                                    <LeadDataFormater
                                        labelText="Status:"
                                        valueText={activity.callStatus}
                                        textColor=""
                                        errorText="-Not Set-"
                                        chipHeight={20}
                                        chipFontSize="0.75rem"
                                        chipfontWeight={500}
                                        isChip={false}
                                    />
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 1 }}
                                >
                                    <Typography sx={{ mr: 2, fontWeight: 500, fontSize: '0.875rem' }}>
                                        Message:
                                    </Typography>
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                                >
                                    <ContentEditor
                                        onChange={() => {}}
                                        sx={{ height: '90%' }}
                                        html={activity.emailBody}
                                        disabled={true}
                                        error={false}
                                        tokenType={TokenType.None}
                                        showToolbar={false}
                                    />
                                </Grid>
                            </Grid>
                        )}
                    {!activity.isAction &&
                        (activity.currentActivityName == 'Outbound Email' ||
                            activity.currentActivityName == 'Inbound Email') && (
                            <Grid container spacing={2} justifyContent={'center'}>
                                <Grid
                                    item
                                    xs={12}
                                    sx={{ pt: 1, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 1 }}
                                >
                                    <Divider />
                                </Grid>
                                <Grid
                                    item
                                    xs={4}
                                    sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                                >
                                    <LeadDataFormater
                                        labelText="From:"
                                        valueText={activity.emailFrom}
                                        textColor=""
                                        errorText="-Not Set-"
                                        chipHeight={20}
                                        chipFontSize="0.75rem"
                                        chipfontWeight={500}
                                        isChip={false}
                                    />
                                </Grid>
                                <Grid
                                    item
                                    xs={4}
                                    sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                                >
                                    <LeadDataFormater
                                        labelText="To:"
                                        valueText={activity.emailTo}
                                        textColor=""
                                        errorText="-Not Set-"
                                        chipHeight={20}
                                        chipFontSize="0.75rem"
                                        chipfontWeight={500}
                                        isChip={false}
                                    />
                                </Grid>
                                <Grid
                                    item
                                    xs={4}
                                    sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                                >
                                    <LeadDataFormater
                                        labelText="CC:"
                                        valueText={activity.emailCC}
                                        textColor=""
                                        errorText="-Not Set-"
                                        chipHeight={20}
                                        chipFontSize="0.75rem"
                                        chipfontWeight={500}
                                        isChip={false}
                                    />
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                                >
                                    <LeadDataFormater
                                        labelText="Subject:"
                                        valueText={
                                            activity.emailSubject != null ? activity.callStartTime.toString() : ''
                                        }
                                        textColor=""
                                        errorText="-Not Set-"
                                        chipHeight={20}
                                        chipFontSize="0.75rem"
                                        chipfontWeight={500}
                                        isChip={false}
                                    />
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 1 }}
                                >
                                    <Typography sx={{ mr: 2, fontWeight: 500, fontSize: '0.875rem' }}>
                                        Email Body:
                                    </Typography>
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                                >
                                    <ContentEditor
                                        onChange={() => {}}
                                        sx={{ height: '90%' }}
                                        html={activity.emailBody}
                                        disabled={true}
                                        error={false}
                                        tokenType={TokenType.None}
                                        showToolbar={false}
                                    />
                                </Grid>
                            </Grid>
                        )}
                    {!activity.isAction &&
                        (activity.currentActivityName == 'Outbound Social Media' ||
                            activity.currentActivityName == 'Inbound Social Media') && (
                            <Grid container spacing={2} justifyContent={'center'}>
                                <Grid
                                    item
                                    xs={12}
                                    sx={{ pt: 1, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 1 }}
                                >
                                    <Divider />
                                </Grid>
                                <Grid
                                    item
                                    xs={4}
                                    sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                                >
                                    <LeadDataFormater
                                        labelText="Platform:"
                                        valueText={activity.socialMediaPlatform}
                                        textColor=""
                                        errorText="-Not Set-"
                                        chipHeight={20}
                                        chipFontSize="0.75rem"
                                        chipfontWeight={500}
                                        isChip={false}
                                    />
                                </Grid>
                                <Grid
                                    item
                                    xs={4}
                                    sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                                >
                                    <LeadDataFormater
                                        labelText="Account:"
                                        valueText={activity.socialMediaUsername}
                                        textColor=""
                                        errorText="-Not Set-"
                                        chipHeight={20}
                                        chipFontSize="0.75rem"
                                        chipfontWeight={500}
                                        isChip={false}
                                    />
                                </Grid>
                                <Grid
                                    item
                                    xs={4}
                                    sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                                ></Grid>
                                <Grid
                                    item
                                    xs={12}
                                    sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 1 }}
                                >
                                    <Typography sx={{ mr: 2, fontWeight: 500, fontSize: '0.875rem' }}>
                                        Message:
                                    </Typography>
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                                >
                                    <ContentEditor
                                        onChange={() => {}}
                                        sx={{ height: '90%' }}
                                        html={activity.emailBody}
                                        disabled={true}
                                        error={false}
                                        tokenType={TokenType.None}
                                        showToolbar={false}
                                    />
                                </Grid>
                            </Grid>
                        )}
                    {activity.isAction &&
                        (activity.actionActivityName == 'Lead Created' ||
                            activity.actionActivityName == 'Lead Edited' ||
                            activity.actionActivityName == 'Lead Deleted') && (
                            <Grid container spacing={2} justifyContent={'center'}>
                                <Grid
                                    item
                                    xs={4}
                                    sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                                >
                                    <LeadDataFormater
                                        labelText="Activity:"
                                        valueText={activity.actionActivityName}
                                        textColor=""
                                        errorText="-Unknown-"
                                        chipHeight={20}
                                        chipFontSize="0.75rem"
                                        chipfontWeight={500}
                                        isChip={false}
                                    />
                                </Grid>
                                <Grid
                                    item
                                    xs={4}
                                    sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                                >
                                    <DateTimeDisplayWithLabel
                                        value={formatDateLocal(activity.currentActivityDate)}
                                        label="Date:"
                                        format="datetime"
                                        sx={{ mr: 2, fontWeight: 500, fontSize: '0.875rem' }}
                                    />
                                </Grid>
                                <Grid
                                    item
                                    xs={4}
                                    sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                                >
                                    <LeadDataFormater
                                        labelText="Completed By:"
                                        valueText={activity.currentActivityOwnerName}
                                        textColor=""
                                        errorText="-Unknown-"
                                        chipHeight={20}
                                        chipFontSize="0.75rem"
                                        chipfontWeight={500}
                                        isChip={false}
                                    />
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 1 }}
                                ></Grid>
                                <Grid
                                    item
                                    xs={12}
                                    sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                                ></Grid>
                            </Grid>
                        )}
                    {activity.isAction && activity.actionActivityName == 'Task Added' && (
                        <Grid container spacing={2} justifyContent={'center'}>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Activity:"
                                    valueText={activity.actionActivityName}
                                    textColor=""
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <DateTimeDisplayWithLabel
                                    value={formatDateLocal(activity.currentActivityDate)}
                                    label="Date:"
                                    format="datetime"
                                    sx={{ mr: 2, fontWeight: 500, fontSize: '0.875rem' }}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Completed By:"
                                    valueText={activity.currentActivityOwnerName}
                                    textColor=""
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Assigned To:"
                                    valueText={activity.taskOwnerName}
                                    textColor=""
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <DateTimeDisplayWithLabel
                                    value={formatDateLocal(activity.taskDueDate)}
                                    label="Due Date:"
                                    format="date"
                                    sx={{ mr: 2, fontWeight: 500, fontSize: '0.875rem' }}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Status:"
                                    valueText="Open"
                                    textColor={activity.taskStatusColor}
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={true}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Created By:"
                                    valueText={activity.taskCreatedByName}
                                    textColor=""
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            ></Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            ></Grid>
                            <Grid
                                item
                                xs={12}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 1 }}
                            >
                                <Typography sx={{ mr: 2, fontWeight: 500, fontSize: '0.875rem' }}>Details:</Typography>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <Typography variant="body2">{activity.taskDetails}</Typography>
                            </Grid>
                        </Grid>
                    )}
                    {activity.isAction && activity.actionActivityName == 'Task Completed' && (
                        <Grid container spacing={2} justifyContent={'center'}>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Activity:"
                                    valueText={activity.actionActivityName}
                                    textColor=""
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <DateTimeDisplayWithLabel
                                    value={formatDateLocal(activity.currentActivityDate)}
                                    label="Date:"
                                    format="datetime"
                                    sx={{ mr: 2, fontWeight: 500, fontSize: '0.875rem' }}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Completed By:"
                                    valueText={activity.currentActivityOwnerName}
                                    textColor=""
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Assigned To:"
                                    valueText={activity.taskOwnerName}
                                    textColor=""
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <DateTimeDisplayWithLabel
                                    value={formatDateLocal(activity.taskDueDate)}
                                    label="Due Date:"
                                    format="date"
                                    sx={{ mr: 2, fontWeight: 500, fontSize: '0.875rem' }}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Status:"
                                    valueText="Complete"
                                    textColor={activity.taskStatusColor}
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={true}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Created By:"
                                    valueText={activity.taskCreatedByName}
                                    textColor=""
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            ></Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            ></Grid>
                            <Grid
                                item
                                xs={12}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 1 }}
                            >
                                <Typography sx={{ mr: 2, fontWeight: 500, fontSize: '0.875rem' }}>Details:</Typography>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <Typography variant="body2">{activity.taskDetails}</Typography>
                            </Grid>
                        </Grid>
                    )}
                    {activity.isAction && activity.actionActivityName == 'Note Added' && (
                        <Grid container spacing={2} justifyContent={'center'}>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Activity:"
                                    valueText={activity.actionActivityName}
                                    textColor=""
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <DateTimeDisplayWithLabel
                                    value={formatDateLocal(activity.currentActivityDate)}
                                    label="Date:"
                                    format="datetime"
                                    sx={{ mr: 2, fontWeight: 500, fontSize: '0.875rem' }}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Completed By:"
                                    valueText={activity.currentActivityOwnerName}
                                    textColor=""
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 1 }}
                            >
                                <Typography sx={{ mr: 2, fontWeight: 500, fontSize: '0.875rem' }}>Details:</Typography>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <Typography variant="body2">{activity.noteDetails}</Typography>
                            </Grid>
                        </Grid>
                    )}
                    {activity.isAction && activity.actionActivityName == 'Owner Assigned' && (
                        <Grid container spacing={2} justifyContent={'center'}>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Activity:"
                                    valueText={activity.actionActivityName}
                                    textColor=""
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <DateTimeDisplayWithLabel
                                    value={formatDateLocal(activity.currentActivityDate)}
                                    label="Date:"
                                    format="datetime"
                                    sx={{ mr: 2, fontWeight: 500, fontSize: '0.875rem' }}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Completed By:"
                                    valueText={activity.currentActivityOwnerName}
                                    textColor=""
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="New Owner:"
                                    valueText={activity.newOwnerName}
                                    textColor=""
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            ></Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            ></Grid>
                        </Grid>
                    )}
                    {activity.isAction && activity.actionActivityName == 'Sprint Assigned' && (
                        <Grid container spacing={2} justifyContent={'center'}>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Activity:"
                                    valueText={activity.actionActivityName}
                                    textColor=""
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <DateTimeDisplayWithLabel
                                    value={formatDateLocal(activity.currentActivityDate)}
                                    label="Date:"
                                    format="datetime"
                                    sx={{ mr: 2, fontWeight: 500, fontSize: '0.875rem' }}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Completed By:"
                                    valueText={activity.currentActivityOwnerName}
                                    textColor=""
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="New Sprint:"
                                    valueText={activity.newSprintName}
                                    textColor=""
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            ></Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            ></Grid>
                        </Grid>
                    )}
                    {activity.isAction && activity.actionActivityName == 'Cadence Assigned' && (
                        <Grid container spacing={2} justifyContent={'center'}>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Activity:"
                                    valueText={activity.actionActivityName}
                                    textColor=""
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <DateTimeDisplayWithLabel
                                    value={formatDateLocal(activity.currentActivityDate)}
                                    label="Date:"
                                    format="datetime"
                                    sx={{ mr: 2, fontWeight: 500, fontSize: '0.875rem' }}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Completed By:"
                                    valueText={activity.currentActivityOwnerName}
                                    textColor=""
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="New Cadence:"
                                    valueText={activity.newCedenceName}
                                    textColor=""
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            ></Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            ></Grid>
                        </Grid>
                    )}
                    {activity.isAction && activity.actionActivityName == 'Marked as Hot' && (
                        <Grid container spacing={2} justifyContent={'center'}>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Activity:"
                                    valueText={activity.actionActivityName}
                                    textColor=""
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <DateTimeDisplayWithLabel
                                    value={formatDateLocal(activity.currentActivityDate)}
                                    label="Date:"
                                    format="datetime"
                                    sx={{ mr: 2, fontWeight: 500, fontSize: '0.875rem' }}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Completed By:"
                                    valueText={activity.currentActivityOwnerName}
                                    textColor=""
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 1 }}
                            ></Grid>
                            <Grid
                                item
                                xs={12}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            ></Grid>
                        </Grid>
                    )}
                    {activity.isAction && activity.actionActivityName == 'Global Update' && (
                        <Grid container spacing={2} justifyContent={'center'}>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Activity:"
                                    valueText={activity.actionActivityName}
                                    textColor=""
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <DateTimeDisplayWithLabel
                                    value={formatDateLocal(activity.currentActivityDate)}
                                    label="Date:"
                                    format="datetime"
                                    sx={{ mr: 2, fontWeight: 500, fontSize: '0.875rem' }}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Completed By:"
                                    valueText={activity.currentActivityOwnerName}
                                    textColor=""
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            ></Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            ></Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            ></Grid>
                        </Grid>
                    )}
                    {activity.isAction && activity.actionActivityName == 'Activity Changed' && (
                        <Grid container spacing={2} justifyContent={'center'}>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Activity:"
                                    valueText={activity.actionActivityName}
                                    textColor=""
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <DateTimeDisplayWithLabel
                                    value={formatDateLocal(activity.currentActivityDate)}
                                    label="Date:"
                                    format="datetime"
                                    sx={{ mr: 2, fontWeight: 500, fontSize: '0.875rem' }}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Completed By:"
                                    valueText={activity.currentActivityOwnerName}
                                    textColor=""
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="New Activity:"
                                    valueText={activity.newActivityName}
                                    textColor=""
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            ></Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            ></Grid>
                        </Grid>
                    )}
                    {activity.isAction && activity.actionActivityName == 'Activity Date Changed' && (
                        <Grid container spacing={2} justifyContent={'center'}>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Activity:"
                                    valueText={activity.actionActivityName}
                                    textColor=""
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <DateTimeDisplayWithLabel
                                    value={formatDateLocal(activity.currentActivityDate)}
                                    label="Date:"
                                    format="datetime"
                                    sx={{ mr: 2, fontWeight: 500, fontSize: '0.875rem' }}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Completed By:"
                                    valueText={activity.currentActivityOwnerName}
                                    textColor=""
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <DateTimeDisplayWithLabel
                                    value={formatDateLocal(activity.actionActivityDate)}
                                    label="New Date:"
                                    format="datetime"
                                    sx={{ mr: 2, fontWeight: 500, fontSize: '0.875rem' }}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            ></Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            ></Grid>
                        </Grid>
                    )}
                    {activity.isAction && activity.actionActivityName == 'Referral to New Lead' && (
                        <Grid container spacing={2} justifyContent={'center'}>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Activity:"
                                    valueText={activity.actionActivityName}
                                    textColor=""
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <DateTimeDisplayWithLabel
                                    value={formatDateLocal(activity.currentActivityDate)}
                                    label="Date:"
                                    format="datetime"
                                    sx={{ mr: 2, fontWeight: 500, fontSize: '0.875rem' }}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Completed By:"
                                    valueText={activity.currentActivityOwnerName}
                                    textColor=""
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            >
                                <LeadDataFormater
                                    labelText="Referral Lead:"
                                    valueText={activity.referralToLeadName}
                                    textColor=""
                                    errorText="-Unknown-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            ></Grid>
                            <Grid
                                item
                                xs={4}
                                sx={{ pt: 4, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                            ></Grid>
                        </Grid>
                    )}
                </Box>
            </PerfectScrollbar>
        );
    } else {
        return <StandardSkeleton />;
    }
};

export default DoActivityDetails;
